import { Sun, Moon } from 'lucide-react'
import { useTheme } from '../contexts/ThemeContext'

export const ThemeToggle = () => {
  const { theme, toggleTheme } = useTheme()

  return (
    <button
      onClick={toggleTheme}
      className="p-2 rounded-full bg-gradient-to-r from-orange-100 to-amber-100 dark:from-gray-700 dark:to-gray-600 border-2 border-orange-200 dark:border-gray-500 hover:from-orange-200 hover:to-amber-200 dark:hover:from-gray-600 dark:hover:to-gray-500 transition-all duration-200"
      aria-label={theme === 'light' ? 'Switch to dark theme' : 'Switch to light theme'}
      title={theme === 'light' ? 'Switch to dark theme' : 'Switch to light theme'}
    >
      {theme === 'light' ? (
        <Moon className="h-5 w-5 text-gray-700" />
      ) : (
        <Sun className="h-5 w-5 text-white" />
      )}
    </button>
  )
}